// extracted by mini-css-extract-plugin
module.exports = {"btn":"OfferWatch_btn__swWDN","active":"OfferWatch_active__qJIu-"};